// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3NNCi","title":"Header_title__Onlbg","left":"Header_left__1fiPx","clinicName":"Header_clinicName__1bK9F"};